import styled from 'styled-components';

export const WarningContainer = styled.div`
  padding: 9px 16px;
  background: ${({ theme }) => theme.colors.tone.lightRed};
  border-radius: 8px;
  margin-top: 11px;
  margin-bottom: 18px;
`;

export const HeaderContainer = styled.div`
  & > div {
    :first-child {
      margin-top: 4px;
    }
    :last-child {
      margin-bottom: 18px;
      margin-top: 8px;
      span {
        margin-left: 4px;
        font-weight: 600;
      }
    }
  }
`;
